import { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { usersService, type UserAutocomplete } from '../services/api';

export const useUserAutocomplete = () => {
  const [query, _setQuery] = useState('');
  const [results, setResults] = useState<UserAutocomplete[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [debouncedQuery] = useDebounce(query, 300);

  const setQuery = (value: string) => {
    _setQuery(value);

    if (value.length < 2) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
  };

  useEffect(() => {
    if (debouncedQuery.length < 2) return;

    let cancelled = false;

    usersService
      .autocompleteUsers(debouncedQuery, 10)
      .then((data) => {
        if (!cancelled) {
          setResults(data);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Failed to autocomplete users:', err);
          setError('Failed to load suggestions');
          setResults([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [debouncedQuery]);

  return {
    query,
    setQuery,
    results,
    loading,
    error,
  };
};
